(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawpro-header"] && !Shopify.designMode) return;
  try {
    
  // PAWPRO Header — sticky scroll detection + mobile drawer
  (function() {
    const header = document.querySelector('[data-pawpro-header]');
    const drawer = document.getElementById('pawpro-mobile-drawer');
    const toggleBtns = document.querySelectorAll('[data-pawpro-drawer-toggle]');
    const closeBtns = document.querySelectorAll('[data-pawpro-drawer-close]');

    // Move drawer to body root — escapes any parent overflow:hidden / stacking context.
    // Defensive : si Shopify wrap notre section dans un parent restrictif (théme parent,
    // shopify-section-group, etc.), le drawer reste rendu en plein écran.
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    // Sticky scroll detection (add backdrop-blur on scroll)
    if (header) {
      let ticking = false;
      const onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            header.dataset.scrolled = window.scrollY > 8 ? 'true' : 'false';
            ticking = false;
          });
          ticking = true;
        }
      };
      const _pawproSectionAbortCtrl = new AbortController();
      document.addEventListener('shopify:section:unload', () => _pawproSectionAbortCtrl.abort(), { once: true });
      window.addEventListener('scroll', onScroll, { passive: true , signal: _pawproSectionAbortCtrl.signal});
      onScroll();
    }

    // Mobile drawer
    if (drawer) {
      const open = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        toggleBtns.forEach(b => b.setAttribute('aria-expanded', 'true'));
        document.body.style.overflow = 'hidden';
      };
      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        toggleBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
        document.body.style.overflow = '';
      };

      toggleBtns.forEach(btn => btn.addEventListener('click', () => {
        drawer.classList.contains('is-open') ? close() : open();
      }));
      closeBtns.forEach(btn => btn.addEventListener('click', close));

      // Esc key closes drawer
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    }

    // Language switcher dropdowns (delegated for HotReload resilience)
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-pawpro-lang-btn]');
      const wrapper = e.target.closest('[data-pawpro-lang]');

      // Toggle on btn click
      if (btn) {
        e.preventDefault();
        const parent = btn.closest('[data-pawpro-lang]');
        if (!parent) return;
        const isOpen = parent.dataset.open === 'true';
        // Close all other open switchers first
        document.querySelectorAll('[data-pawpro-lang][data-open="true"]').forEach(el => {
          if (el !== parent) {
            el.dataset.open = 'false';
            const b = el.querySelector('[data-pawpro-lang-btn]');
            if (b) b.setAttribute('aria-expanded', 'false');
          }
        });
        parent.dataset.open = isOpen ? 'false' : 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        return;
      }

      // Click outside any switcher → close all
      if (!wrapper) {
        document.querySelectorAll('[data-pawpro-lang][data-open="true"]').forEach(el => {
          el.dataset.open = 'false';
          const b = el.querySelector('[data-pawpro-lang-btn]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Esc closes language switcher
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-pawpro-lang][data-open="true"]').forEach(el => {
          el.dataset.open = 'false';
          const b = el.querySelector('[data-pawpro-lang-btn]');
          if (b) {
            b.setAttribute('aria-expanded', 'false');
            b.focus();
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
